import React from 'react';

const testimonials = [
  {
    quote: "Spiked Qcumber designed and delivered a cutting-edge data ingestion system that transformed how we process mortgage applications at scale. The pipeline handles millions of records daily with exceptional reliability — a foundational platform we'll build on for years.",
    client: "One of Canada's Largest Mortgage Brokers",
    tag: 'Data Ingestion & Engineering',
    icon: '🏦',
    color: 'bg-blue-600',
  },
  {
    quote: "As a global HR and payroll leader serving customers from Australia to Europe and across North America, we needed a partner who could operate at our scale. Spiked Qcumber delivered a Power Platform and AI solution that streamlined operations across every region we serve.",
    client: 'Leading HR/Payroll Company in North America',
    tag: 'Global Platform Modernization',
    icon: '🌐',
    color: 'bg-indigo-600',
  },
  {
    quote: "Our app-based exercise training platform needed an AI backbone that could personalize workouts and adapt in real time. Spiked Qcumber integrated OpenAI and Claude to create an intelligent coaching engine that has dramatically improved user engagement and health outcomes.",
    client: 'AI-Driven Healthcare & Exercise Training App',
    tag: 'AI Integration & Health Tech',
    icon: '🏃',
    color: 'bg-teal-600',
  },
  {
    quote: "We are one of the largest lab providers in America and needed to modernize our data infrastructure to support rapid growth. Spiked Qcumber built a Databricks lakehouse that unified our lab data, enabled real-time reporting, and cut our reporting cycle from days to minutes.",
    client: "One of America's Largest Lab Providers",
    tag: 'Databricks & Enterprise Analytics',
    icon: '🔬',
    color: 'bg-orange-600',
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-primary">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-white mb-4">What Our Clients Say</h2>
          <p className="text-blue-200 text-lg max-w-xl mx-auto">
            Trusted by enterprises across North America to deliver transformative technology outcomes.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-2xl p-7 shadow-lg flex flex-col">
              <div className="text-4xl text-blue-200 mb-4 font-serif leading-none">"</div>
              <p className="text-gray-600 leading-relaxed flex-grow mb-6">{t.quote}</p>
              <div className="flex items-center gap-3">
                <div className={`${t.color} w-11 h-11 rounded-full flex items-center justify-center text-white text-xl flex-shrink-0`}>
                  {t.icon}
                </div>
                <div>
                  <div className="font-bold text-gray-900">{t.client}</div>
                  <div className="text-gray-500 text-sm">{t.tag}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
